import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';
import PgdManageLayout from './layouts/PgdManageLayout';

const PgdListPage = lazy(() => import('./use-cases/PgdListPage'));
const PgdCreatePage = lazy(() => import('./use-cases/PgdCreatePage'));
const PgdEditPage = lazy(() => import('./use-cases/PgdEditPage'));
const CategoryListPage = lazy(() => import('./use-cases/CategoryListPage'));
const CategoryCreatePage = lazy(() => import('./use-cases/CategoryCreatePage'));
const CategoryEditPage = lazy(() => import('./use-cases/CategoryEditPage'));

const PgdManageConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: false,
            organisationSelector: false,
          },
        },
      },
    },
  },
  auth: authRoles.support,
  routes: [
    {
      path: 'pgd-manage',
      element: <PgdManageLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="pgds" replace />,
        },
        {
          path: 'pgds',
          element: <PgdListPage />,
        },
        {
          path: 'pgds/new',
          element: <PgdCreatePage />,
        },
        {
          path: 'pgds/:id',
          element: <PgdEditPage />,
        },
        {
          path: 'categories',
          element: <CategoryListPage />,
        },
        {
          path: 'categories/new',
          element: <CategoryCreatePage />,
        },
        {
          path: 'categories/:id',
          element: <CategoryEditPage />,
        },
      ],
    },
  ],
};

export default PgdManageConfig;
